import dayjs from "dayjs";

export const getAge = (dob: string) => {
  const birthDate = dayjs(dob);
  const age = dayjs().diff(birthDate, "year");
  return age;
};

export const getAdultDate = () => {
  const currentDate = dayjs();
  return currentDate.subtract(18, "year");
};

export const get30YearsBack = () => {
  const currentDate = dayjs();
  return currentDate.subtract(30, "year");
};

export const getNYearsBack = (n: number) => {
  const currentDate = dayjs();
  return currentDate.subtract(n, "year");
};

export const getToday = () => {
  return dayjs();
};
